var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svgSrc)?_c('div',{staticClass:"c-inline-svg",domProps:{"innerHTML":_vm._s(_vm.svgSrc)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }